export default __webpack_public_path__ + "static/media/program_sample.47576ecf.svg";